import { caption as captionFactory } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils';

/**
 * @name caption_node
 */

export var caption = captionFactory({
  parseDOM: [{
    tag: 'figcaption[data-caption]'
  }],
  toDOM: function toDOM() {
    var attrs = {
      'data-caption': 'true'
    };
    return ['figcaption', attrs, 0];
  }
});
export var captionWithLocalId = captionFactory({
  parseDOM: [{
    tag: 'figcaption[data-caption]',
    getAttrs: function getAttrs() {
      return {
        localId: uuid.generate()
      };
    }
  }],
  toDOM: function toDOM(node) {
    var _node$attrs;
    var attrs = {
      'data-caption': 'true',
      'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
    };
    return ['figcaption', attrs, 0];
  }
});